<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="tni">This is a work of fiction. In certain instances the names of real newspapers and magazines have been used as a literary device, but the headlines, journalists’ names and content of the articles are all entirely fictional. These articles, journalists and all other names, characters and descriptions of events in the book are the product of the author’s imagination, and any resemblance to actual persons or events is entirely coincidental.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmtext.vue?1fa2ad61